import React from 'react';
import PropTypes from 'prop-types';
import {Form, Input} from "antd";

const GovIpaCodeFormItem = (props) => {
    const {intl, form, isEntityType1, formItemLayout, disabled, initialValue} = props;

    return (
        <Form.Item className="ant-row ant-from-item"
                   label={intl.formatMessage({id: 'contact.detail.form.registrant.ipaCode'})}
                   {...formItemLayout}
                   hasFeedback
        >
            {form.getFieldDecorator('registrant.gov.ipaCode', {
                initialValue: initialValue ,
                rules: [{required: props.required,    message: intl.formatMessage({id: 'contact.detail.form.registrant.ipaCode.message'}),}]
            })(
                <Input
                    disabled={disabled}
                    style={isEntityType1 ? {textTransform: 'uppercase'} : {}}
                    //il campo una volta impostato, non è più modificabile
                />)
            }
        </Form.Item>
    );
};

GovIpaCodeFormItem.propTypes = {
    intl: PropTypes.object,
    form: PropTypes.object,
    isEntityType1: PropTypes.bool,
    formItemLayout: PropTypes.object,
    disabled: PropTypes.bool,
    initialValue: PropTypes.string,

};
GovIpaCodeFormItem.defaultProps = {
    disabled: false
};

export default GovIpaCodeFormItem;
